import '../pipeline/trade_program/trade_program.scss';

require.context('../pipeline/trade_program/try-on-wall', true);
require.context('../pipeline/trade_program/images', true);

window.asyncLoadScript = (scriptURL, condition) => new Promise((resolve, reject) => {
  if (condition) {
    resolve();
    return;
  }
  const script = document.createElement('script');
  script.src = scriptURL;
  script.async = true;
  script.onload = () => resolve();
  script.onerror = (error) => reject(error);
  document.body.appendChild(script);
});
